/* dataexport.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 768 768">
    <title></title>
    <path class="foreground-gl" d="M608 384v224h-448v-224h-64v224c0 35.2 28.8 64 64 64h448c35.2 0 64-28.8 64-64v-224h-64zM416 405.44l82.88-82.56 45.12 45.12-160 160-160-160 45.12-45.12 82.88 82.56v-309.44h64v309.44z"></path>
    </svg>
    `
};